import React from 'react'

import Modal from '@Modal/V3/Modal'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'

const modal_bemit = ['mobile-app-add'];

export default function MobileAppModal (props)
{
	return (
		<Modal open={ props.open === true } bemit={ modal_bemit }
			onClose={ props.onClose }>
			<a href="https://www.synergies.site/application-mobile"
				target="_blank" rel="noreferrer">
				<Image src="/images/visuel_telechargez_l_appli_synergies.jpg"
					alt="Téléchargez l'application mobile Synergies"
					className="mobile-app-presentation-img"
				/>
			</a>
			<Loader className="c-loader" bemit={ ['primary', 'bg-white'] } />
		</Modal>
	);
}